/* Suresh Peddavoora 11/01/2022 2698708322  Added Class Name for select dropdown  Enhancements */

import React, {useContext} from 'react';
import {Checkbox, makeStyles} from '@material-ui/core';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import SelectTabContextProvider from '../../../components/SelectTabContext/SelectTabContext';
import GuiAutoComplete from '../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../components/FormComponents/GuiTextField';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;

const useStyles = makeStyles((theme) => ({
  root: {
    'color': '#43096b',
    '&$checked': {
      color: '#43096b',
    },
  },
  inputRoot: {
    color: '#FF0000',
  },

  focused: {
    border: '1px solid #fff',
  },

  option: {
    padding: '6px 16px',
    fontSize: '16px',
    [theme.breakpoints.down('md')]: {
      padding: '6px 10px',
      fontSize: '12px',
    },
  },
  checkBox: {
    marginRight: 8,
    padding: 9,
    [theme.breakpoints.down('md')]: {
      marginRight: 0,
      padding: 5,
    },
  },
}));

export default function SelectComponent() {
  const classes = useStyles();

  const {setSelectedCMTabs, selectedCMTabs, ClientNewTabData} =
    useContext(SelectTabContextProvider);
  const handleOnChange = (event, value) => {
    setSelectedCMTabs(value);
  };
  return (
    // <div className={classes.root}>
    <div className="client-maintenance-dropdown">
      <GuiAutoComplete
        multiple
        classes={{
          popper: classes.popper,
          option: classes.option,
        }}
        disableCloseOnSelect
        size="small"
        limitTags={3}
        fullWidth
        value={selectedCMTabs}
        onChange={handleOnChange}
        className="select-tab-autocomplete-dropdown1"
        id="select-tab"
        options={ClientNewTabData}
        getOptionLabel={(option) => option.label}
        renderOption={(option, {selected}) => (
          <React.Fragment>
            <Checkbox
              icon={icon}
              checkedIcon={<CheckBoxIcon fontSize="small" className={classes.root} />}
              checked={selected}
              className={classes.checkBox}
            />
            {option.label}
          </React.Fragment>
        )}
        renderInput={(params) => <GuiTextField {...params} label="Select Tab(s)" variant="outlined" />}
        renderTags={(tagValue) => {
          return tagValue.map((option, index) => (
            <span className="text-white" key={index}>
              {option.code}
              {index !== tagValue.length - 1 && ','}
            </span>
          ));
          // return <span>W1,W2, W100</span>;
        }}
      />
    </div>
  );
}
